import React from 'react';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setConfirmationModal } from 'modules/global';

import { TestTime } from 'components';

const Header = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const testData = useAppSelector(({ nationalCertificate }) => nationalCertificate.test);

  const onFinish = () => {
    dispatch(setConfirmationModal(true));
  };

  return (
    <div className="z-11 fixed bottom-0 left-0 right-0 bg-primary lg:sticky lg:top-0 lg:rounded-b-xl lg:pt-4">
      <div className="flex items-center justify-between rounded-none bg-white px-3 py-2 md:rounded-xl shadow">
        <TestTime countdownMinutes={Math.round((testData?.hour || 0) * 60)} time={testData?.started_time} />
        <button
          onClick={onFinish}
          className="cursor-pointer rounded-lg border-none bg-red-50 px-5 py-2.5 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white"
        >
          {t('yakunlash')}
        </button>
      </div>
    </div>
  );
};

export default Header;
